import { Injectable } from '@angular/core';
import { NavigationService } from './navigation.service';
import { BehaviorSubject } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { ActionPerformed, PushNotificationSchema } from '@capacitor/push-notifications';
import { GlobalMethodsService } from '../global-methods.service';
import { StorageService } from './storage.service';
import { GlobalVariablesService } from '../global-variables.service';
import { PanelConfService } from './panel-conf.service';
import { Installation } from '../../models/Installation';
import { Router } from '@angular/router';
import { TranslateConfigService } from './translate-config.service';
import { NavController } from '@ionic/angular';
@Injectable({
  providedIn: 'root'
})
export class EventNotificationService {

  public notifications = new BehaviorSubject<any>(null);
  public $redirectNotifications = new BehaviorSubject<boolean>(null);
  checkSinsChangeInterval = 0;
  checkLimit = 0;

  constructor(
    private navigation: NavigationService,
    public gms: GlobalMethodsService,
    private storage: StorageService,
    public gvs: GlobalVariablesService,
    private navCtrl: NavController,
    private router: Router,
    private translate: TranslateConfigService
  ) { }

  public subscribeNotifications() {
    this.notifications.pipe(filter(Boolean)).subscribe(async (notification: any | PushNotificationSchema | ActionPerformed) => {
      const notificationData = notification.data ?? notification.notification.data;
      const user = await this.storage.getObject(this.gvs.AUTH_KEY);
      if (notificationData.email != null && notificationData.email !== '' && notificationData.s_ins != null && notificationData.s_ins !== '') {
        if (user != null && user.userName != null && user.userName !== '') {
          if (user.userName.toUpperCase() === notificationData.email.toUpperCase()) {
            if (this.router.url === '/' || this.router.url.includes('/splash-screen') || this.router.url.includes('/reset-password') || this.router.url.includes('/register')
              || this.router.url.includes('/validate-account')) {
              this.gvs.notificationData = notificationData;
            } else {
              await this.checkSIns(notificationData);
              this.checkSinsChangeInterval = window.setInterval(async () => {
                if (this.gvs.currentInstallation.s_ins == notificationData.s_ins) {
                  await this.redirectNotification(notificationData);
                  window.clearInterval(this.checkSinsChangeInterval);
                  this.checkSinsChangeInterval = 0;
                  this.checkLimit = 0;
                }
                if (this.checkLimit >= 5) {
                  window.clearInterval(this.checkSinsChangeInterval);
                  this.checkSinsChangeInterval = 0;
                  this.checkLimit = 0;
                  await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), this.translate.getTranslate('MESSAGES.openNotificationKO'),
                    'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
                }
              }, 1000);
            }
          } else {
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), this.translate.getTranslate('MESSAGES.openNotificationKO'),
              'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }
        } else {
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), this.translate.getTranslate('MESSAGES.userNotLogged'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
      }
    });
  }

  async checkSIns(notificationData) {
    if (this.gvs.currentInstallation.s_ins !== notificationData.s_ins) {
      let installations: Installation[] = await this.storage.getObject(this.gvs.CONF_INSTALLATIONS + '_' + this.gvs.user.userName);
      const installation: Installation = installations.find(x => x.s_ins == notificationData.s_ins);
      this.gms.setChangeInstallationEvent(installation);
    }
  }

  async redirectNotification(notificationData) {
    if (notificationData.screen != null && notificationData.screen !== '') {
      switch (notificationData.screen.toUpperCase()) {
        case 'OPENCLOSE':
          await this.navigation.goTo('/home');
          break;
        case 'SVRQ':
          await this.gms.openMaintenanceModal(notificationData);
          break;
        case '5CIBER':
          await this.navigation.goTo('/cyber-safeguard');
          break;
        case '0CIBER':
          this.gms.setStatusAlarm(true);
          await this.navigation.goTo('/alarm');
          break;
        case 'BURGLARY':
          await this.gms.openHistoricalModal(notificationData);
          break;
        case 'PHOTO':
          if (!this.router.url.includes('/cameras')){
            await this.navigation.goTo('/cameras');
            this.gms.setPicNotifEvent(notificationData);
          } else {
            this.gms.setPicNotifEvent(notificationData);
          }
          break;
        /*case 'SUPPORT':
          await this.gms.initChat(this.gvs.user.userName, 4);
          break;
        case 'EMERGENCY':
          await this.gms.initChat(this.gvs.user.userName, 0);
          break;*/
        default:
          await this.navigation.goTo('/home');
          break;
      }
      if (this.gvs.notificationData != null) {
        this.gvs.notificationData = null;
      }
    }else{
      await this.navigation.goTo('/home');
    }
  }

  async subscribeRedirectNotification() {
    this.$redirectNotifications.subscribe(async (value) => {
      if (value) {
        await this.redirectNotification(this.gvs.notificationData);
      }
    });
  }
}
